import { Link, useParams } from "react-router-dom";
import { resolveDetail } from "@/lib/content";
import WorkDetail from "./components/WorkDetail";
import ArticleDetail from "./components/ArticleDetail";
import useDocumentTitle from "@/hooks/useDocumentTitle";

export default function DetailPage() {
  const { id } = useParams<{ id: string }>();
  const result = resolveDetail(id ?? "");

  const title =
    result.kind === "work"
      ? `${result.work.title} - 黑皮辣妹`
      : result.kind === "news"
        ? `${result.news.title} - 黑皮辣妹`
        : result.kind === "plot"
          ? `${result.plot.title} - 黑皮辣妹`
          : "内容不存在 - 黑皮辣妹";

  const description =
    result.kind === "work"
      ? result.work.synopsis.slice(0, 80)
      : result.kind === "news"
        ? result.news.summary.slice(0, 80)
        : result.kind === "plot"
          ? result.plot.summary.slice(0, 80)
          : undefined;

  useDocumentTitle(title, description);

  if (result.kind === "none") {
    return (
      <div className="hp-fade-up w-full px-4 md:px-6 pt-32 pb-24">
        <div className="max-w-lg mx-auto text-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16">
          <span className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-secondary-100 mb-4">
            <i className="ri-emotion-sad-line text-3xl text-secondary-500" />
          </span>
          <h1 className="font-heading font-black text-2xl text-foreground-950 mb-3">
            您访问的作品不存在或已删除
          </h1>
          <p className="text-sm text-foreground-500 mb-6">
            该内容可能已被移除，或链接有误。你可以返回首页或浏览作品库继续发现好内容。
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm font-medium px-5 py-2.5 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/category/works"
              className="inline-flex items-center gap-2 border border-foreground-300 text-foreground-800 text-sm font-medium px-5 py-2.5 rounded-md hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-film-line" />
              浏览作品库
            </Link>
          </div>
        </div>
      </div>
    );
  }

  if (result.kind === "work") {
    return <WorkDetail work={result.work} />;
  }

  if (result.kind === "news") {
    return <ArticleDetail kind="news" item={result.news} />;
  }

  return <ArticleDetail kind="plot" item={result.plot} />;
}